import { useLayoutEffect, useState } from 'react';

/**
 * Current width of `ref`'s element, kept up to date with a ResizeObserver.
 * Lets a component adapt to the room it actually has (a sidebar or a docked
 * panel may take part of the screen), not to the window. `initialWidth` is
 * used until the first measurement, which happens before the first paint.
 */
const useElementWidth = (ref, initialWidth = 0) => {
  const [width, setWidth] = useState(initialWidth);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const update = () => {
      const next = Math.round(element.getBoundingClientRect().width);
      setWidth((prev) => (prev === next ? prev : next));
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return width;
};

export default useElementWidth;
